<template>
  <div class="top_nav">
<!--    <div class="temporary">-->
<!--      <div @click="clickNav(1)">111</div>-->
<!--      <div @click="clickNav(2)">222</div>-->
<!--      <div @click="clickNav(3)">333</div>-->
<!--    </div>-->
    <div class="home_width">
      <login class="login" :show="show"></login>
      <logo class="logo" :logo="logo"></logo>
      <search class="top_search"></search>
      <div class="nav">
        <!-- <div class="point" @click="clickNav(1)">亚马逊运营基础与技巧</div>
        <div class="point" @click="clickNav(2)">亚马逊FBA利润计算</div> -->
        <div class="point" v-if="false" @click="clickNav(3)" style="display: flex;align-items: center">
          <img src="../../assets/img/播放.png" style="margin-right: 5px;width: 16px" alt="">
          操作视频</div>
      </div>
    </div>
  </div>
</template>

<script>
  import logo from "./logo";
  import navLogin from "./navLogin";
  import topSearch from "./topSearch";

  export default {
    name: "top",
    components: {
      "logo": logo,
      "login": navLogin,
      "search": topSearch
    },
    props:{
      show:{
        type: Boolean,
        default: false
      },
      logo:{
        type: Boolean,
        default: false
      }
    },
    methods: {
      clickNav(index){
        if(index === 0){
          this.$router.push('/index')
        }else if(index === 1){
          // location. reload()
          this.$router.push({
            path: '/operation',
            query: {
              newsType: '3'
            }
          })
        }else if(index === 2){
          this.$router.push({
            path: '/operation',
            query: {
              newsType: '7'
            }
          })
        }else if(index === 3){
          this.$router.push({
            path: '/operation',
            query: {
              newsType: '10000'
            }
          })
        }
      }
    },
    watch: {
      '$route' (to, from){
        this.$router.go(0);
        if(to.query.newsType != from.query.newsType){
          this.newsType = to.query.newsType;
          this.init();
        }
      }
    },
    created() {
      if(this.$router.query){
        this.newsType = this.$router.query.newsType
        this.init()
      }
    }
  }
</script>

<style scoped>
  .point{
    cursor: pointer;
  }
  .top_nav{
    display: flex;
    justify-content: center;
    background-color: #022028;
    /* max-height: 125px; */
    position: relative;
    background-color: rgba(0,0,0,.3);
    max-height: 115px;
  }

  .home_width{
    /* background-color: #022028; */
    /* background-color: rgba(241,244,249,.1); */
    width: 70%;
    position: relative;
    /* margin: 5px 0 5px 0; */
  }

  .nav{
    /*position: absolute;*/
    /*bottom: 0;*/
    /*right: 190px;*/
    /* float: right; */
    color: white;
    display: flex;
    align-self: start;
    text-align: end;
    transform: translateY(-20px);
    position: absolute;
    right: 10%;
  }

  .logo{
    flex: 1;
    text-align: start;
    align-self: center;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    /* transform: translateY(1px); */
  }

  .top_search{
    flex: 6;
    text-align: justify;
    justify-content: center;
  }

  .login{
    /*flex: 2;*/
    float: right;
    align-self: start;
    text-align: end;
    margin: 20px 0;
    transform: translateX(100px);
  }

  .temporary{
    position: absolute;
    top: 0;
    left: 0;
  }

  .temporary div{
    cursor: pointer;
    margin: 10px 0;
    color: #022028;
  }

  @media screen and (max-width: 1600px) {
    .top_nav{
      min-width: 118rem;
      /* max-height: 90px; */
    }

    /*.logo{*/
    /*  margin-left: -140px;*/
    /*}*/

    .top_search{
      padding-right: 38px;
    }

    .nav{
      /*right: 170px;*/
    }

    .nav div{
      padding: 0 0.5rem 0 0;
    }

    .home_width{
      min-width: 110rem;
    }
  }

  @media screen and (min-width: 1600px){
    .top_nav{
      min-width: 1580px;
      /* max-height: 115px; */
    }

    .top_search{
      padding-right: 38px;
    }

    .nav div{
      padding: 5px 10px;
    }

    .home_width{
      min-width: 1500px;
    }
  }
</style>
